import { render } from "./SmDetailProperties.vue?vue&type=template&id=ed893dc6&scoped=true"
import script from "./SmDetailProperties.vue?vue&type=script&lang=js"
export * from "./SmDetailProperties.vue?vue&type=script&lang=js"

import "./SmDetailProperties.vue?vue&type=style&index=0&id=ed893dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed893dc6"]])

export default __exports__